import React from "react";
import Sidebar from "./../components/sidebar";
import Header from "./../components/Header";
import MainFaq from "../components/faqs/MainFaqs";

const FaqScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainFaq />
      </main>
    </>
  );
};

export default FaqScreen;
